<template>
    <div class="main bg-waves">
        <section id="brn-error" class="diagonal">
            <BorderDecoration class="top-left outside d-none d-md-block" style="left: -50px; top: 25px" :primary="'var(--color-secondary)'" :secondary="'var(--color-gray-light)'"/>
            <div class="container text-center">
                <ChalkDecoration class="m-auto">
                    <h2 class="">Sitemap</h2>
                </ChalkDecoration>
                <ul class="list-styled text-start text-primary">
                    <li v-for="page in $attrs.pages">
                        <template v-if="page.items">
                            {{ page.title }}
                            <ul class="list-styled">
                                <li v-for="item in page.items">
                                    <a :href="item.slug">{{ item.title }}</a>
                                </li>
                            </ul>
                        </template>
                        <a v-else :href="page.slug">{{ page.title }}</a>
                    </li>
                </ul>
            </div>
        </section>
    </div>
</template>

<script>
import BorderDecoration from "../components/elements/BorderDecoration";
import ChalkDecoration from "../components/elements/ChalkDecoration";
import SettingsMixin from "../../mixins/SettingsMixin";
import ErrorHandlerMixin from "../../cms/mixins/ErrorHandlerMixin";
export default {
    name: "Sitemap",
    mixins: [SettingsMixin, ErrorHandlerMixin],
    components: {ChalkDecoration, BorderDecoration}
}
</script>

<style scoped>

</style>
